import { SmileOutlined } from '@ant-design/icons';
import { t } from '@hefe/i18n';
import { Button, Result, Space } from 'antd';

interface NewVersionModalComponentProps {
  version: string;
  onButtonClick: () => void;
}

export default function NewVersionModalComponent(
  props: NewVersionModalComponentProps
) {
  return (
    <Result
      icon={<SmileOutlined />}
      title={t('update.modal.text', { version: props.version })}
      extra={
        <Space direction="vertical">
          <Button onClick={() => props.onButtonClick()} type="primary">
            {t('update.modal.button')}
          </Button>
        </Space>
      }
    />
  );
}
